(() => {
  const update = () => {
    document.querySelectorAll('[data-jr-countdown]').forEach(offer => {
      const remaining = Math.max(0, Math.ceil((Date.parse(offer.dataset.jrCountdown) - Date.now()) / 1000));
      offer.hidden = remaining === 0;
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60)];
      offer.querySelectorAll('[data-jr-time]').forEach((part, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (part.textContent !== value) part.textContent = value;
      });
    });
  };
  update();
  setInterval(update, 1000);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', update);
})();
